export const EMPTY_ROUTE = '/';
export const PAGE_START = '/sections';
export const ROUTES_PAGE = '/routes';
export const SECTION_FULL_PAGE = '/sections/full';
